import { CheckCircle } from "@phosphor-icons/react";
import { Icon } from "@phosphor-icons/react";
import { BillNetwork } from "../../../../hooks/useBillAirtimeProviders";
import BillModal from "./BillModal";
import { useState } from "react";

interface ProviderSelectModalProps {
  open: boolean;
  onClose: () => void;
  providers: BillNetwork[];
  selectedCode?: string;
  onSelect: (provider: BillNetwork) => void;
  label?: string;
  icon: Icon;
}

/**
 * Modal grid of providers (networks / discos / cable providers). Selecting one
 * closes the modal so the user drops straight back to the compact form.
 */
const ProviderSelectModal = ({
  open,
  onClose,
  providers,
  selectedCode,
  onSelect,
  label = "provider",
  icon: ProviderIcon,
}: ProviderSelectModalProps) => {
  const [search, setSearch] = useState("");
  const handleClose = () => { setSearch(""); onClose(); };
  const filtered = providers.filter(provider =>
    `${provider.name} ${provider.code}`.toLowerCase().includes(search.trim().toLowerCase()));
  return (
    <BillModal
      open={open}
      onClose={handleClose}
      title={`Select ${label}`}
      description="Choose the provider for this purchase."
    >
      {providers.length > 6 && <input value={search} onChange={event => setSearch(event.target.value)}
        aria-label={`Search ${label}`} placeholder={`Search ${label}...`}
        className="w-full rounded-xl border border-gray-300 px-4 py-3 mb-3" />}
      <div className="grid grid-cols-2 gap-3">
        {filtered.map((provider) => {
          const active = selectedCode === provider.code;
          return (
            <button
              key={provider.code}
              type="button"
              onClick={() => {
                onSelect(provider);
                handleClose();
              }}
              className={`rounded-2xl border p-4 text-left transition flex flex-col gap-3 ${
                active
                  ? "border-visaro-orange bg-visaro-orange/5 text-visaro-orange"
                  : "border-gray-200 hover:border-visaro-orange/60"
              }`}
            >
              <div className="flex items-center justify-between">
                <span className="w-10 h-10 rounded-full bg-visaro-orange/10 text-visaro-orange flex items-center justify-center">
                  <ProviderIcon size={20} weight="bold" />
                </span>
                {active && <CheckCircle size={20} weight="fill" />}
              </div>
              <span className="font-bold text-gray-900 leading-tight">
                {provider.name}
              </span>
            </button>
          );
        })}
      </div>
      {!filtered.length && <p role="status" className="p-4 text-center text-gray-500">No providers found.</p>}
    </BillModal>
  );
};

export default ProviderSelectModal;
